import React, { useEffect, useRef } from 'react';

export function editableHtml(element) {
    const copy = element.cloneNode(true);
    copy.querySelectorAll('[data-jodit-selection_marker], [data-diagramacao-caret], [id^="jodit_selection_marker"]').forEach(marker => marker.remove());
    return copy.innerHTML;
}

export default function InlineSheetBlock({ html, onChange, className = '' }) {
    const element = useRef(null);
    const initial = useRef(html);
    useEffect(() => {
        const node = element.current;
        if (node && !node.hasAttribute('data-jodit-active') && !node.contains(document.activeElement) && node.innerHTML !== html) node.innerHTML = html;
    }, [html]);
    return <div ref={element} data-inline-editor contentEditable suppressContentEditableWarning className={'diagramacao-inline-block jodit-wysiwyg ' + className}
        onInput={event => onChange(editableHtml(event.currentTarget))} dangerouslySetInnerHTML={{ __html: initial.current }} />;
}
